module.exports = __webpack_public_path__ + "static/media/search.34fba856.svg";